package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class ClubClientDto(
    val userId: String,
    val username: String,
    val fullName: String? = null,
    val avatarUrl: String? = null,
    val phone: String? = null,
    val email: String,
    val status: String,
    val bookingCount: Long,
    val totalSpend: String,
    val lastVisitDate: String? = null,
    val unpaidCount: Int = 0
)

@Serializable
data class ClubClientCardDto(
    val userId: String,
    val username: String,
    val fullName: String? = null,
    val avatarUrl: String? = null,
    val phone: String? = null,
    val email: String,
    val status: String,
    val bookingCount: Long,
    val totalSpend: String,
    val lastVisitDate: String? = null,
    val favoriteFieldId: String? = null,
    val favoriteFieldName: String? = null,
    val isBlocked: Boolean = false,
    val notes: List<ClubClientNoteDto> = emptyList(),
    val debts: List<BookingDto> = emptyList()
)

@Serializable
data class ClubClientNoteDto(
    val id: String,
    val authorId: String,
    val text: String,
    val createdAt: String
)

@Serializable
data class AddClientNoteRequest(
    val text: String
)

@Serializable
data class BlockClientRequest(
    val reason: String? = null
)

@Serializable
data class ClubClientsPageDto(
    val clients: List<ClubClientDto>,
    val total: Int,
    val page: Int,
    val size: Int,
    val activeCount: Int = 0,
    val totalBookings: Long = 0,
    val totalRevenue: String = "0"
)
